var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43066 7.47852C6.37067 7.47852 7.94336 5.90583 7.94336 3.96582C7.94336 2.02581 6.37067 0.453125 4.43066 0.453125C2.49066 0.453125 0.917969 2.02581 0.917969 3.96582C0.917969 5.90583 2.49066 7.47852 4.43066 7.47852Z",
    fill: "#123051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43066 5.91732V5.91453M4.43066 5.08096C4.43066 3.82643 5.60156 4.10521 5.60156 3.12946C5.60156 2.51359 5.07733 2.01432 4.43066 2.01432C3.90637 2.01432 3.46257 2.3425 3.31337 2.79492M7.94336 3.96582C7.94336 5.90583 6.37067 7.47852 4.43066 7.47852C2.49066 7.47852 0.917969 5.90583 0.917969 3.96582C0.917969 2.02581 2.49066 0.453125 4.43066 0.453125C6.37067 0.453125 7.94336 2.02581 7.94336 3.96582Z",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo2);
export default __webpack_public_path__ + "static/media/info2.06bf969489a255fb4e1379190bd0ab1f.svg";
export { ForwardRef as ReactComponent };